import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "component/ui/Dialog";
import { Button } from "component/ui/Button";
import { ConfettiSuccessIcon } from "asset/icons";

const AccountOpeningSuccessModal = ({
  isOpen = false,
  onClose,
  onDone,
}) => {
  if (!isOpen) return null;

  const handleDoneClick = () => {
    if (onDone) {
      onDone();
    } else if (onClose) {
      onClose();
    }
  };


  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose && onClose()}>
      <DialogContent
        showCloseButton={true}
        className="max-w-[560px] w-full rounded-[16px] bg-white shadow-2xl overflow-hidden border-0"
      >
        <div className="p-6 sm:p-8">
          {/* Confetti & Checkmark Graphic */}
          <div className="flex justify-center items-center -mt-2 mb-2">
            <ConfettiSuccessIcon className="w-32 h-32 md:w-36 md:h-36 shrink-0" />
          </div>

          {/* Header */}
          <div className="flex flex-col items-center text-center">
            <DialogTitle className="text-xl sm:text-2xl font-semibold text-success-title tracking-tight">
              Account activated successfully
            </DialogTitle>
            <DialogDescription className="text-sm text-slate-text font-[350] leading-relaxed px-1 mx-auto mt-1">
              You can proceed to the dashboard to start transacting
            </DialogDescription>
          </div>

        </div>

        {/* Footer Actions */}
        <div className="border-t border-solid border-card-bg flex p-6 sm:py-6 sm:px-8 items-center justify-end w-full">

          {/* Done button */}
          <Button
            type="button"
            onClick={handleDoneClick}
            className="!bg-btn-dark hover:!bg-btn-dark/80 text-white font-medium text-sm rounded-[8px] px-6 h-11 transition-all cursor-pointer shadow-xs"
          >
            Take me to my dashboard
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AccountOpeningSuccessModal;
